import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Subject, takeUntil } from 'rxjs';
import { DetailDataOrderModel, orderDetails } from 'src/app/models/detail-data-order.model';
import { OrderService } from 'src/app/services/api/order.service';

@Component({
  selector: 'app-pickup-order',
  standalone: false,
  templateUrl: './pickup-order.component.html',
  styleUrl: './pickup-order.component.scss'
})
export class PickupOrderComponent {
  destroy$ = new Subject();
  loading: boolean = true;
  orderID: number = 0;
  detailOrder!: orderDetails[];
  address: string = '';
  pickupMethod: string = '';
  expedition: string = '';
  vehicle: string = '';
  orderNumber: string = '';
  shipping: string = '';

  constructor(
    private route: Router,
    private message: NzMessageService,
    private orderService: OrderService,
    private activeRoute: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
    this.getDetailOrder();
  }

  back() {
    this.route.navigate(['order-data']);
  }

    getDetailOrder() {
      this.activeRoute.params.subscribe((params) => {
        this.orderID = Number(params['id']);
      });
  
      this.orderService
        .detailDataOrder(this.orderID)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (res) => {
            this.detailOrder = res.data.order_details;
            this.address = res.data.receiver_address;
            this.pickupMethod = res.data.shipping_type;
            this.expedition = res.data.shipping_logo;
            this.orderNumber = res.data.order_no;
            this.shipping = res.data.shipping;
          },
          () => {}
        );
    }

  submitRequest() {
    const params = {
      orders: [
        {
          order_no: this.orderNumber,
        },
      ],
    }
    this.orderService.requestPickup(params).subscribe(
      (res) => {
        this.message.success('Request submitted successfully!');

        this.route.navigate(['order-data/order-detail/' + this.orderID]);
      }, (err) => {
        this.message.error('Request failed to submit, please try again later');}
    );
  }

  cancelRequest() {
    this.orderService.cancelPickup({ order_no: this.orderNumber }).subscribe(
      (res) => {
        this.message.success('Request canceled successfully!');

        this.route.navigate(['order-data/order-detail/' + this.orderID]);
      }, (err) => {
        this.message.error('Request failed to cancel, please try again later');}
    );
  }
}
